export enum TemplateType {
  F0 = 'product-info.f0', // F0 产品头图
  F11 = 'product-info.f1-1', // F1-1 全屏单图
  F12 = 'product-info.f1-2', // F1-2 水平单图
  F13 = 'product-info.f1-3', // F1-3 垂直单图
  F14 = 'product-info.f1-4', // F1-4单图+标签
  F15 = 'product-info.f1-5', // F1-5 单图+标签
  F21 = 'product-info.f2-1', // F2-1 双图1
  F31 = 'product-info.f3-1', // F3-1 三图1
  F32 = 'product-info.f3-2', // F3-2 三图2
  F4 = 'product-info.f4', // F4 四图
  F51 = 'product-info.f5-1', // F5-1 五图1
  F52 = 'product-info.f5-2', // F5-2 五图2
  F61 = 'product-info.tab-1-f6-1', // F6-1 Tab切换1
  F62 = 'product-info.tab-2-f6-2', // F6-2 Tab切换2
  F71 = 'product-info.icon-1-f7-1', // F7-1 功能Icon
  F72 = 'product-info.icon-1-f7-2', // F7-2 功能Icon
  F73 = 'product-info.icon-1-f7-3', // F7-3 功能Icon
  F74 = 'product-info.icon-1-f7-4', // F7-4 功能Icon
  C1 = 'product-info.c1', // C1 配件模块
  C2 = 'product-info.c2', // C2 多卡片-平铺
  C21 = 'product-info.c2-1', // C2-1 多卡片-可翻转
  C22 = 'product-info.c2-2', // C2-2 多卡片-弹窗
  C3 = 'product-info.c3', // C3 参数模块
  C4 = 'product-info.c4', // C4 底部注释模块
  C5 = 'product-info.c5', // C5 全屏图片平铺
  C6 = 'product-info.c6', // C6 产品对比
  C7 = 'product-info.c7', // C7 悬浮窗
  S1 = 'product-info.s1', // S1 葫芦广告屏
  S2 = 'product-info.s2', // S2 葫芦配件
  S3 = 'product-info.s3', // S3 文滑动+图固定
  S4 = 'product-info.s4', // S4 CC1

  // F0 = 'product-info.f0', // F0 产品头图
  // FullScreenSingleMedia = 'product-info.f1-1', // F1-1 全屏单图
  // HorizontalSingleMedia = 'product-info.f1-2', // F1-2 水平单图
  // VerticalSingleMedia = 'product-info.f1-3', // F1-3 垂直单图
  // SingleMediaAndTags = 'product-info.f1-4', // F1-4、F1-5 单图+标签
  // HorizontalMutipleMedia = 'product-info.f2-1', // F2-1、F3-2、F4 双图1、三图2、四图
  // MainAndTwoSubMedia = 'product-info.f3-1', // F3-1 三图1
  // FeaturedMediaGrid = 'product-info.f5-1', // F5-1 五图1
  // MainAndFourSubMedia = 'product-info.f5-2', // F5-2 五图2
  // TopTabSwitch = 'product-info.tab-1-f6-1', // F6-1 Tab切换1
  // TabSwiperCard = 'product-info.tab-2-f6-2', // F6-2 Tab切换2
  // IconTagArray = 'product-info.icon-1-f7-1', // F7-1、F7-2、F7-3、F7-4 功能Icon
  // AccessoriesPanel = 'product-info.c1', // C1 配件模块
  // MultiCardTiling = 'product-info.c2', // C2 多卡片-平铺
  // FlipMultipleCards = 'product-info.c2-1', // C2-1 多卡片-可翻转
  // ProductParamsPanel = 'product-info.c3', // C3 参数模块
  // NotesBar = 'product-info.c4', // C4 底部注释模块
  // FullScreenTiling = 'product-info.c5', // C5 全屏图片平铺
  // ComparePanel = 'product-info.c6', // C6 产品对比
  // FloatRobot = 'product-info.c7', // C7 悬浮窗
  // S1 = 'product-info.s1', // S1 葫芦广告屏
  // S2 = 'product-info.s2', // S2 葫芦配件
  // ScrollSwitchMedia = 'product-info.s3', // S3 文滑动+图固定
  // S4 = 'product-info.s4', // S4 CC1

  // Banner = 'Banner',
  // BackgroundImageText = 'BackgroundImageText', // 背景图文
  // TextCard = 'TextCard', // 纯文字卡片
  // ImageTextCardArray = 'ImageTextCardArray', // 图文卡片排列
  // ScrollSwiperCard = 'ScrollSwiperCard', // 滚动轮播
  // ProductSpecification = 'ProductSpecification', // 产品详情
  // ComparisonTable = 'ComparisonTable', // 各产品对比
  // ContactUs = 'ContactUs', // 联系我们按钮
}

export enum Theme {
  Dark = 'dark',
  Light = 'light',
  Gray = 'gray',
}

export const DefaultTheme: Theme = Theme.Light

export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
export type SemanticTextTag = HeadingTag | 'p'

export enum BannerType {
  Animation = 'Animation',
  Swiper = 'Swiper',
  BackGroundImage = 'BackGroundImage',
}

export enum TextPosition {
  Left = 'Left',
  Right = 'Right',
}

export enum AspectRatio {
  OneToOne = '1/1',
  OneToTwo = '1/2',
  TwoToOne = '2/1',
  TwoToThree = '2/3',
  ThreeToTwo = '3/2',
  ThreeToFour = '3/4',
  FourToThree = '4/3',
  NineToSixteen = '9/16',
  SixteenToNine = '16/9',
}

interface Base {
  theme?: Theme
}

export interface BaseText extends Base {
  title?: string
  desc?: string
}

// F0 产品头图
export interface IFirstScreen extends Base {
  mediaUrl?: string
  mediaH5Url?: string
  mediaAlt?: string
  mediaH5Alt?: string
  titleUrl?: string
  subTitle?: string
  subTitleTag?: HeadingTag | null
  videoUrl?: string
  maskColor?: string
  maskDegree?: number
}

// F1-1 全屏单图
export interface IFullScreenSingleMedia extends BaseText {
  titleTag?: HeadingTag | null
  mediaUrl?: string
  mediaH5Url?: string
  maskColor?: string
  maskDegree?: number
}

// F1-2 水平单图
/** 后端可配置的 padding 预设值（字符串格式，对应 PC 端 px 值） */
export type SectionPaddingValue = 'px0' | 'px16' | 'px32' | 'px48' | 'px64' | 'px80' | 'px100' | 'px120' | 'px160'

/**
 * PC 端预设值 → 移动端(值/2) + PC 端 的 Tailwind padding-top 类映射
 * 移动端自动取 PC 值的一半
 */
export const paddingTopClassMap: Record<SectionPaddingValue, string> = {
  px0: 'pt-0 laptop:pt-0',
  px16: 'pt-2 laptop:pt-4',
  px32: 'pt-4 laptop:pt-8',
  px48: 'pt-6 laptop:pt-12',
  px64: 'pt-8 laptop:pt-16',
  px80: 'pt-10 laptop:pt-20',
  px100: 'pt-50px laptop:pt-25',
  px120: 'pt-15 laptop:pt-30',
  px160: 'pt-20 laptop:pt-40',
}

/**
 * PC 端预设值 → 移动端(值/2) + PC 端 的 Tailwind padding-bottom 类映射
 * 移动端自动取 PC 值的一半
 */
export const paddingBottomClassMap: Record<SectionPaddingValue, string> = {
  px0: 'pb-0 laptop:pb-0',
  px16: 'pb-2 laptop:pb-4',
  px32: 'pb-4 laptop:pb-8',
  px48: 'pb-6 laptop:pb-12',
  px64: 'pb-8 laptop:pb-16',
  px80: 'pb-10 laptop:pb-20',
  px100: 'pb-50px laptop:pb-25',
  px120: 'pb-15 laptop:pb-30',
  px160: 'pb-20 laptop:pb-40',
}

export interface IHorizontalSingleMediaProps extends BaseText {
  titleTag?: HeadingTag | null
  itemTitleTag?: HeadingTag | null
  mediaGroup: Array<{
    mediaUrl: string
    title?: string
    desc?: string
    infoGroup?: Array<{ title?: string; desc?: string; icon?: string; fontColor?: string }>
  }>
  mediaAspectRatio?: AspectRatio
  mediaBorderRadius?: number
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// F1-3 垂直单图
export interface IVerticalSingleMedia extends BaseText {
  titleTag?: HeadingTag | null
  titleClassName?: string
  titleSupClassName?: string
  backgroundClassName?: string
  tagGroup?: Array<{ title?: string; desc?: string; icon?: string }>
  mediaGroup?: Array<{
    mediaUrl?: string
    mediaH5Url?: string
    tabTitle?: string
    desc?: string
  }>
  mediaAspectRatio?: AspectRatio
  mediaAspectRatioH5?: AspectRatio
  mediaBorderRadius?: number
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// F1-4、F1-5 单图+标签
export interface ISingleMediaAndTags extends BaseText {
  type?: 'F1-4' | 'F1-5'
  mediaUrl?: string
  mediaH5Url?: string
  tagGroup?: Array<{
    title?: string
    desc?: string
    mediaUrl?: string
  }>
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// F2-1、F3-2、F4 双图1、三图2、四图
export interface IHorizontalMutipleMedia extends IMutipleMedia {
  type?: 'F2-1' | 'F3-2' | 'F4'
  mediaGroup: Array<
    IMutipleMedia['mediaGroup'][number] & {
      /** 仅 F2-1 生效，未配置或 null 时保持开启。 */
      enableHoverScale?: boolean | null
    }
  >
  titleTag?: HeadingTag | null
  itemTitleTag?: HeadingTag | null
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// F3-1、F5-1、F5-2、S3 三图1、五图1、五图2、文滑动+图固定
export interface IMutipleMedia extends BaseText {
  mediaGroup: Array<{
    mediaUrl?: string
    mediaH5Url?: string
    title?: string
    desc?: string
    fontColor?: string
  }>
  mediaAspectRatio?: AspectRatio
  mediaBorderRadius?: number
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// F6-1 Tab切换1
export interface ITopTabSwitch extends IMutipleMedia {
  mediaGroup: Array<{
    mediaUrl?: string
    tabTitle?: string
    title?: string
    subTitle?: string
    desc?: string
    downloadTitle?: string
    downloadUrl?: string
    jumpUrl?: string
  }>
}

// F6-2 Tab切换2
export interface ITabSwiperCard extends BaseText {
  mediaUrlList?: Array<string>
  tabPanels?: Array<{ tab: string; panel: string }>
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// F7-1、F7-2、F7-3、F7-4 功能Icon
export interface IIconTagArray extends Base {
  type?: 'F7-1' | 'F7-2' | 'F7-3' | 'F7-4' // 1: 标题，icon偏左，小字号；2：标题，icon居中，小字号；3：标题，icon居中，大字号；默认：1
  title?: string
  align?: 'left' | 'center' | 'right' // icon 相对于文字的对齐方式，默认 center
  dataList: Array<{
    mediaUrl?: string
    title?: string
    desc?: string
  }>
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// C1 配件模块
export interface IAccessoriesPanel extends BaseText {
  titleTag?: HeadingTag | null
  productCode: string
  mediaBorderRadius?: number
  mediaH5BorderRadius?: number
  dataList: Array<{
    partId: string
    name: string
    imageUrl: string
    desc: string
    categoryTagName: string
    imageUrlList: Array<string>
  }>
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// C2 多卡片-平铺
export interface IMultiCardTiling extends BaseText {
  titleTag?: HeadingTag | null
  itemTitleTag?: HeadingTag | null
  mediaGroup: Array<{
    title: string
    mediaUrl: string
  }>
  borderRadius?: number
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

export type SectionElementItemType = {
  title: string // 卡片-标题
  desc?: string // 卡片-背面-描述
  color?: string // 卡片-正面-标题颜色 0：黑色；1：白色
  mediaUrl: string // 卡片-正面-图片地址
}

export type SectionElementType = {
  name: string // tab-name
  title: string // 底部-标题
  subTitle: string // 底部-副标题
  desc?: string // 底部-描述
  borderRadius?: number // 卡片-圆角
  items: Array<SectionElementItemType>
}

// C2-1 多卡片-可翻转
export interface IFlipMultipleCards extends Base {
  dataList: Array<SectionElementType>
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

export type CardModalListType = {
  title: string
  desc?: string
  mediaUrl?: string
  textColor?: string
  modalTitle?: string
  modalDesc?: string
  modalMediaGroup?: Array<{
    mediaUrl?: string
    title?: string
    desc?: string
  }>
}

// C2-2 多卡片-弹窗
export interface IMultiCardModal extends Base {
  borderRadius?: number
  dataList?: Array<{
    tabTitle?: string
    bottomTitle?: string
    bottomSubTitle?: string
    bottomDesc?: string
    downloadTitle?: string
    downloadUrl?: string
    cardList?: Array<CardModalListType>
  }>
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// C3 参数模块
export interface IProductParamsPanelProps extends BaseText {
  titleTag?: HeadingTag | null
  backgroundClassName?: string
  imgUrl?: string
  paramsList?: Array<{
    label: string
    value: Array<string>
    gap: string
  }>
  btntext?: string
  iframe?: boolean
  // titleText?: string
  // lightBgc?: string
  // darkBgc?: string
  robot?: string
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// C4 底部注释模块
export interface INotesBar extends Base {
  dataList: Array<{
    title: string
    desc: string
  }>
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// C5 全屏图片平铺
export interface IFullScreenTiling extends BaseText {
  mediaGroup: Array<{
    mediaUrl: string
  }>
  aspectRatio?: string
  borderRadius?: string
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

export type ComparePanelCardProps = {
  title?: string
  colors?: Array<{
    color: string
    imgUrl?: string
  }>
  defaultActiveColor?: string
  introduceArr: Array<{
    title: string
    desc: string
  }>
}

// C6 产品对比
export interface IComparePanel extends BaseText {
  robotCode?: string // 联系我们-按钮跳转
  dataList: Array<ComparePanelCardProps>
  showColor?: boolean // 控制是否展示颜色切换
  /** 区块顶部间距（PC 端 px 值，移动端自动减半） */
  paddingTop?: SectionPaddingValue
  /** 区块底部间距（PC 端 px 值，移动端自动减半） */
  paddingBottom?: SectionPaddingValue
}

// C7 悬浮窗
export interface IFloatRobot extends Base {
  robot: string
  color: string // border及按钮背景色
  hideCircleBorder?: boolean
  href?: string
  buttonText?: string
  buttonTextColor?: string
  buttonTextSize?: 'small' | 'default' | 'large'
}

// S1 葫芦广告屏
export interface IS1 extends BaseText {
  productMedia?: string
  innerMediaUrlList?: Array<string>
}

// S2 葫芦配件
export interface IS2 extends Base {
  infoItemList?: Array<{
    title?: string | null
    desc?: string | null
  }>
  mediaUrlList?: Array<string>
}

// S4 CC1
export interface IS4 extends BaseText {
  titleTag?: HeadingTag | null
  itemTitleTag?: HeadingTag | null
  mediaUrl: string
  tagList?: Array<{
    title?: string
    mediaUrl?: string
  }>
}

export interface IBanner extends Base {
  type: BannerType
  title?: string
  slogan?: string
  illustration?: string
  description?: string
  video?: string
  images: Array<string>
}

export interface IBackgroundImageText extends Base {
  cover: boolean
  mediaUrl?: string
  title?: string
  description?: string
}

export interface ITextCard extends Base {
  title?: string
}

export interface IImageTextCardItem extends Base {
  mediaList: string[]
  textPosition?: TextPosition
  textList?: Array<{ title?: string; description?: string }>
}

export interface IImageTextCardArray extends Base {
  title?: string
  description?: string
  dataList: Array<IImageTextCardItem>
}

export interface IScrollSwiperItem extends Base {
  title?: string
  description?: string
  mediaUrl: string
}

export interface IScrollSwiperCard extends Base {
  title?: string
  dataList: Array<IScrollSwiperItem>
}

export interface IProductSpecification extends Base {
  icon: string
  specifications: Array<[string, string]>
  showContactUsButton?: boolean
}

export interface IComparisonTable extends Base {
  title: string
  labelWidth?: string
  columns: { label: string; icon: string }[]
  rows: { label: string; values: (string | boolean)[] }[]
  showContactUsButton?: boolean
}

export interface ITipsBar extends Base {
  title?: string
  dataList: Array<string>
}

export interface IContactUs extends Base {
  content: string
}

export interface IMetaComponent {
  template: TemplateType
  data:
    | IFirstScreen // F0 产品头图
    | IFullScreenSingleMedia // F1-1 全屏单图
    | IHorizontalSingleMediaProps // F1-2 水平单图
    | IVerticalSingleMedia // F1-3 垂直单图
    | ISingleMediaAndTags // F1-4、F1-5 单图+标签
    | IHorizontalMutipleMedia // F2-1、F3-2、F4 双图1、三图2、四图
    | IMutipleMedia // F3-1、F5-1、F5-2 三图1、五图1、五图2
    | ITopTabSwitch // F6-1 Tab切换1
    | ITabSwiperCard // F6-2 Tab切换2
    | IIconTagArray // F7-1、F7-2、F7-3、F7-4 功能Icon
    | IAccessoriesPanel // C1 配件模块
    | IMultiCardTiling // C2 多卡片-平铺
    | IFlipMultipleCards //  C2-1 多卡片-可翻转
    | IMultiCardModal // C2-2 多卡片-弹窗
    | IProductParamsPanelProps // C3 参数模块
    | INotesBar // C4 底部注释模块
    | IFullScreenTiling // C5 全屏图片平铺
    | IComparePanel // C6 产品对比
    | IFloatRobot // C7 悬浮窗
    | IS1 // S1 葫芦广告屏
    | IS2 // S2 葫芦配件
    | IS4 // S4 CC1
  // | IBanner
  // | IBackgroundImageText
  // | ITextCard
  // | IImageTextCardArray
  // | IScrollSwiperCard
  // | IProductSpecification
  // | IComparisonTable
  // | ITipsBar
  // | IContactUs
}

export type MetaPage = Array<IMetaComponent>
